<template>
    <section>
        <div class="o-color-change" data-logo-colors="logo-icon-is-color-1-darker, logo-text-is-color-1-darker"></div>
        <div class="o-grid -push-2 sm-md:push-1">
            <div class="o-grid-8 md:10 sm:12">
                <h2 class="c-cart__title o-title-2">Panier d’achat</h2>
                <template v-if="!isEmpty(cart.items)">
                    <div class="c-cart__item" :class="{'-is-open': item.edit }" v-for="(item, index) in cart.items" :key="item.product_id">
                        <div class="c-cart__item-header">
                            <div class="c-cart__product-name">
                                <h3 class="c-cart__product__name">{{ item.name }}</h3>
                                <span v-if="item.description" class="c-cart__product-name__spacer"></span>
                                <p  v-if="item.description" class="c-cart__product__description">{{ item.description }}</p>
                                <h3 v-if="item.type == 'cdj'" class="c-cart__product__information">{{ item.metadata.first_name }} {{ item.metadata.last_name }}</h3>
                            </div>
                            

                            <div class="c-cart__product-btn__wrapper">
                                <button v-if="item.type == 'cdj'" class="c-cart__product-btn-expend" @click="item.edit = !item.edit">
                                    <!-- <?php svg('arrow-up-cart', '-icon-cart -icon-cart-arrow'); ?> -->
                                    <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-arrow">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#arrow-up-cart"></use>
                                    </svg>
                                    <!-- <?php svg('inscription', '-icon-cart -icon-cart-edit'); ?> -->
                                    <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart -icon-cart-edit">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#inscription"></use>
                                    </svg>
                                </button>
                                <button class="c-cart__product-btn-delete" @click="deleteProduct(item.product_id)">
                                    <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#trash"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div v-if="item.edit" class="c-cart__item-detail">
                            <div class="c-cart__item-detail__inner">
                                <div v-if="groups[getGroupIndex(item.metadata.group.id)]" class="c-cart-detail">
                                    <template v-for="week in groups[getGroupIndex(item.metadata.group.id)].weeks" :key="week.term_id">
                                        <div @click="selectWeek(index, week)" class="c-cart-detail__item" :class="{'-complet': ((week.metadata.total_place == week.count || week.metadata.total_place - week.count < 1) && !item.metadata.weeks.includes(week.term_id)), '-is-selected': item.metadata.weeks.includes(week.term_id)}">
                                            <div class="c-cart-detail__label__wrapper"><span class="c-cart-detail__label" v-html="getGroupStatus(week, item)"></span></div>
                                            <div class="c-cart-detail__infos">
                                                <p class="c-cart-detail__date">24 au 28 juin</p>
                                                <p class="c-cart-detail__description">{{ week.name }}</p>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="c-cart-form">
                                    <h4 class="o-title-5">Informations de l’enfant</h4>
                                    <form class="o-form " data-module="FocusLabel">
                                        <div class="o-form__row">
                                            <div class="o-form__group">
                                                <input class="o-input" type="text" id="prenom" name="Prénom" :class="{'-input-filled' : item.metadata.first_name }" v-model="item.metadata.first_name" @change="updateDistantCart()" required>
                                                <label class="o-label" for="prenom">Prénom</label>
                                            </div>
                                            <div class="o-form__group">
                                                <input class="o-input" type="text" id="nom" name="Nom" :class="{'-input-filled' : item.metadata.last_name }" v-model="item.metadata.last_name" @change="updateDistantCart" required>
                                                <label class="o-label" for="nom">Nom</label>
                                            </div>
                                            <div class="o-form__group">
                                                <label class="sr-only" for="age">Âge</label>
                                                <div class="o-select__wrap">
                                                    <select class="o-select" v-model="item.metadata.group.id" @change="updateDistantCart" id="age" name="Âge" required>
                                                        <option value="Âge" disabled selected>Âge</option>
                                                        <option v-for="group in groups" :key="group.term_id" :value="group.term_id">{{ group.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="o-row">
                        <div class="o-col w-1/2">
                            <div class="c-cart__empty">
                                <h3>Votre panier est vide</h3>
                                <p>Vous n'avez pas encore d'articles dans votre panier.</p>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="cart.items && cart.items.length > 0" class="c-cart__pay-button" @click="checkout()">
                    <button class="o-button o-button-cart" target="_blank" aria-label="Payer">
                        <span class="o-button__text">Payer</span>
                        <span class="sr-only">Payer</span>
                        <!-- <?php svg('pay', '-icon-arrow-full-right'); ?> -->
                        <svg aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#pay"></use>
                        </svg>  
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
//Import axios
import axios from 'axios'

export default {
    name: 'ProductCart',
    data() {
        return {
            cart: {},
            token: null,
            showTaxes: window.ajax_var.showTaxes,
            groups: [],
            error: null,
        }
    },
    methods: {
        getCart() {
            //Fetch cart from API
            if (this.$store.state.token) {
                this.token = this.$store.state.token
            }
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                rand: Math.floor(Math.random() * 1000000)
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce

            axios.get('/wp-json/stereostore/v1/cart', { params })
                .then(response => {
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    if(this.cart.lock){
                        this.cart.lock = false
                        this.updateDistantCart(this.token)
                    }
                    //Parse metadata
                    for (let i = 0; i < this.cart.items.length; i++) {
                        if (this.cart.items[i].type == 'cdj') this.fetchCDJ();
                        //check if metadata is a string
                        if (typeof this.cart.items[i].metadata === 'string') {
                            this.cart.items[i].metadata = JSON.parse(this.cart.items[i].metadata)
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getGroupIndex(id){
            return this.groups.findIndex(group => group.term_id == id)
        },
        getGroupStatus(week, item){
            if((week.metadata.total_place == week.count || week.metadata.total_place - week.count < 1) && !item.metadata.weeks.includes(week.term_id)) return 'Complet'
            if(week.metadata.total_place - week.count < 5) return 'Places <br>limitées'
            return 'Disponible'
        },
        async selectWeek(index, week){
            let groups = await this.fetchCDJ();
            //Check if week is complete
            //Get week in group

            if(this.cart.items[index].metadata.weeks.includes(week.term_id)){
                this.cart.items[index].metadata.weeks = this.cart.items[index].metadata.weeks.filter(item => item !== week.term_id)
            } else {
                let is_full = false
                groups[this.getGroupIndex(this.cart.items[index].metadata.group.id)].weeks.forEach(week1 => {
                    if(week.term_id == week1.term_id){
                        if(week1.metadata.total_place == week1.count || week1.metadata.total_place - week1.count < 1){
                            alert('Cette semaine est déjà complète')
                            is_full = true
                            return
                        }
                    }
                })

                if(is_full) return
                this.cart.items[index].metadata.weeks.push(week.term_id)
            }
            this.updateItemDescription(index);
            this.updateDistantCart()
        },
        updateItemDescription(index){
            let weeks = this.cart.items[index].metadata.weeks.map(week => {
                return this.groups[this.getGroupIndex(this.cart.items[index].metadata.group.id)].weeks.find(item => item.term_id == week).name.replace('Semaine ', '')
            })
            this.cart.items[index].description = 'Semaine '+weeks.join(', ')
            this.cart.items[index].total = 0
            this.cart.items[index].price = 0
            //Update total
            this.cart.items[index].metadata.weeks.forEach(week => {
                this.cart.items[index].price += parseInt(this.groups[this.getGroupIndex(this.cart.items[index].metadata.group.id)].weeks.find(item => item.term_id == week).metadata.price)
                this.cart.items[index].total += parseInt(this.groups[this.getGroupIndex(this.cart.items[index].metadata.group.id)].weeks.find(item => item.term_id == week).metadata.price)
            })

        },
        async fetchCDJ(){
            let random = Math.floor(Math.random() * 1000000)
            return axios.get('/wp-json/cdj/v1/groups', { params: { random } })
                .then((response) => {
                    this.groups = response.data;
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                    return error;
                });
        },
        updateCart(token) {
            this.$store.commit('updateToken', token)
        },
        updateQty(index) {
            //Update total
            if(this.cart.items[index].quantity < 1) {
                this.cart.items[index].quantity = 1
            }
            this.cart.items[index].total = this.cart.items[index].price * this.cart.items[index].quantity
            this.updateDistantCart()
        },
        async updateDistantCart() {
            let params = {
                cart: this.cart,
                token: this.token,
                _wpnonce: window.ajax_var.nonce
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            return axios.put('/wp-json/stereostore/v1/cart', params)
                .then(response => {
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.updateCart(this.token)

                    //Parse metadata
                    for (let i = 0; i < this.cart.items.length; i++) {
                        //Check if string or object
                        if (typeof this.cart.items[i].metadata === 'string') {
                            this.cart.items[i].metadata = JSON.parse(this.cart.items[i].metadata)
                        }
                    }
                    return response
                })
                .catch(error => {
                    console.log(error)
                })
        },
        isEmpty(array) {
            return !Array.isArray(array) || !array.length
        },
        formatMoney(value) {
            let language = 'fr';
            let currency = 'CAD';
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
        deleteProduct(id) {
            if (!confirm('Voulez-vous vraiment supprimer ce produit ?')) {
                return;
            }
            this.cart.items = this.cart.items.filter(item => item.product_id !== id)
            this.updateDistantCart()
        },
        async checkout() {
            this.cart.lock = true;
            let response = await this.updateDistantCart()
            console.log(response)
            if(response.data.success) location.href = '/caisse/'
            else {
                this.error = response.data.message
                this.cart.lock = false
            }
        },
        calculateTaxes() {
            let taxes = this.cart.taxes
            let total = 0
            for (let i = 0; i < taxes.length; i++) {
                total += taxes[i].amount
            }
            return this.formatMoney(total)
        },
    },
    mounted() {
        this.getCart()
        document.body.className.split(' ').forEach(function (className) {
            if (className.match(/^u-/)) {
                document.body.classList.remove(className);
            }
        });
        //Add class to body u-bg-color-1 u-color-1-darker
        document.body.classList.add('u-bg-color-1', 'u-color-1-darker', 't-cart')
        document.querySelector('.c-footer__inner').classList.add('u-bg-color-3-darker', 'u-color-3-light')
        document.querySelector('.c-footer').style.display = 'none'
    }
}
</script>